import * as React from 'react';

import {getAssistantIdByAgentKey, registerTool} from './helpers';
import type {AgentKey, Chatbot} from './helpers';

import {useInitializeChatbot} from '.';

import styles from './team-ai-sidebar.module.css';

type Props = {
    agentKey: AgentKey;
    onInitializeChatbot: (chatbot: Chatbot) => void | null | undefined;
    pageContext: string | null | undefined;
};

export function TeamAiAgent(props: Props) {
    const {onInitializeChatbot} = props;

    const chatbot = useInitializeChatbot(props.agentKey);

    React.useEffect(() => {
        if (chatbot && onInitializeChatbot) {
            // Callback to update the context of the chatbot and
            // any other onInitializeChatbot logic
            onInitializeChatbot(chatbot);
        }
    }, [chatbot, onInitializeChatbot]);

    React.useEffect(() => {
        if (chatbot) {
            registerTool(
                chatbot,
                'searchPage',
                "Get the page context for the user's current page. This is a very useful tool, you should use it if you have it and when any other tool is called regarding the current page.",
                () => {
                    return {success: true, response: props.pageContext};
                }
            );
        }

        return () => {
            if (chatbot) {
                chatbot.unregisterTool('searchPage');
            }
        };
    }, [chatbot, props.pageContext]);

    return (
        <div
            data-chatbot-id={getAssistantIdByAgentKey(props.agentKey) as string}
            data-chatbot-mode='standard'
            data-hide-header='true'
            className={styles['i-frame-container']}
        ></div>
    );
}
